import React from 'react';
import Immutable from 'immutable';
import ParentBoundComponent from '../../components/parentboundcomponent';
import Module from '../module';
import EntitySearchAndDetailModel from './entitysearchanddetailmodel';
import Button from '../../components/forms/button';
import styled from 'styled-components';
import Icon from '../../components/icon';
import { getPhrase } from '../../data/phrases';


const NewRowButton = styled.div`
	position: absolute;
	right: 4px;
	bottom: 0px;
	color: ${props => props.theme.lightButtonColor};
	cursor: pointer;
	opacity: 0.2;
	text-align: center;

	.text {
		visibility: hidden;
	}

	&:hover {
		opacity: 1;
		.text {
			visibility: visible;
		}
	}

	.icon {
		font-size: 48px;
	}
`;

export default class EntitySearchAndDetailModule extends ParentBoundComponent {
	constructor() {
		super();

		this.onSearchRowAction = this.onSearchRowAction.bind(this);
		this.getSearchRowClass = this.getSearchRowClass.bind(this);
		this.hideDetail = this.hideDetail.bind(this);
		this.openNewEntity = this.openNewEntity.bind(this);
	}

	async openNewEntity() {
		let model = await this.getModel().showNewDetail();
		this.setData(model.getData());
	}

	getModel() {
		return new EntitySearchAndDetailModel(this.getData());
	}

	async showDetail(id) {
		let model = await this.getModel().showDetail(id);
		this.setData(model.getData());
	}

	onSearchRowAction(row) {
		this.showDetail(row.get('id'));
	}

	getSearchRowClass(row) {
		return 'actionable';
	}

	hideDetail() {
		this.setData(this.getModel().hideDetail().getData());
	}

	handleEvent(eventType, params) {
	}

	render() {
		const data = this.getData();
		const inDetail = data.get('isDetailOpen');
		if (inDetail) {
			return (
				<Module
					appState={data.get('detail')}
					onDataChange={newData => {
						this.setData(data.setIn(['detail', 'data'], newData));
					}}
					toolbarLeft={(
						<Button
							type="light"
							text={getPhrase('backToOverview')}
							iconName="back"
							onAction={this.hideDetail}
						/>
					)}
				/>
			);
		} else {
			return (
				<Module
					appState={data.get('search')}
					onDataChange={newData => {
						this.setData(data.setIn(['search', 'data'], newData));
					}}
					getRowClass={this.getSearchRowClass}
					onRowAction={this.onSearchRowAction}
					customResultProps={this.props.customResultProps}
					onNewEntityRequested={this.openNewEntity}
					bottomRightToolbar={!!data.get('newRowMode') && (
						<Button
						//	type="light"
							text={getPhrase('new.' + data.get('entityName'))}
							iconName="add"
							onAction={this.openNewEntity}
						/>
					)}
				/>
			);
		}
	}
}

